import { render, staticRenderFns } from "./TableItemForManualGrading.vue?vue&type=template&id=424c8022"
import script from "./TableItemForManualGrading.vue?vue&type=script&lang=js"
export * from "./TableItemForManualGrading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports